import { useState, useEffect } from 'react'
import { UserRole } from '../types'
import { apiService, ApiError } from '../services/api'

interface UseUserRolesResult {
 roles: UserRole[]
 isLoading: boolean
 error: string | null
 refetch: () => Promise<void>
}

export const useUserRoles = (): UseUserRolesResult => {
 const [roles, setRoles] = useState<UserRole[]>([])
 const [isLoading, setIsLoading] = useState(true)
 const [error, setError] = useState<string | null>(null)

 const fetchRoles = async () => {
 try {
 setIsLoading(true)
 setError(null)
 
 const response = await apiService.getUserRoles()
 const responseData = response.data || response
 
 // A API retorna { roles: [...] }, então pegamos a propriedade roles
 const rolesData = (responseData as any).roles || responseData
 setRoles(Array.isArray(rolesData) ? rolesData : [])
 } catch (err) {
 const errorMessage = err instanceof ApiError 
 ? err.message 
 : 'Erro ao carregar perfis de usuários'
 
 setError(errorMessage)
 console.error('Erro ao buscar perfis:', err)
 setRoles([])
 } finally {
 setIsLoading(false)
 }
 }

 useEffect(() => {
 fetchRoles()
 }, [])

 const refetch = async () => {
 await fetchRoles()
 }

 return {
 roles,
 isLoading,
 error,
 refetch
 }
}
